<template>
  <section id="main-wrap" class="pure-g">
    <div id="main-col" class="pure-u-3-5">

      <h3>Search results for <span>{{this.$route.params.term}}</span></h3>

      <div id="search-results-grapes" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="500">
        <Grape v-for="grape in grapes" :grapeInstance="grape" :key="grape.id" />
      </div>

    </div>
  </section>

</template>

<script>
  /* global algoliasearch, mixpanel */
  import Grape from './Grape.vue'

  export default {
    name: 'search',
    data () {
      return {
        grapes: [],
        loading: true,
        search: '',
        pageLimit: 20,
        currentPage: 0,
        isLoading: false,
        enableLoadMore: true,
        grapesDatabase: this.$globals.grapesDatabase,
        grapevinesDatabase: this.$globals.grapevinesDatabase,
        isPress: this.$globals.isPress
      }
    },
    watch: {
      '$route': function () {
        this.displaySearchResults()
      }
    },
    created () {
      this.displaySearchResults()
    },
    methods: {
      displaySearchResults () {
        let vm = this
        mixpanel.track(
          'Search created',
          {
            'term': vm.$route.params.term
          }
        )
        vm.grapes = []
        vm.currentPage = 0
        var client = algoliasearch('BLP5M7YD97', 'e43146fabb439a15a2622c0264710cb6')
        var index = client.initIndex(vm.grapesDatabase)
        var query = vm.$route.params.term
        index.search({
          query: query,
          hitsPerPage: vm.pageLimit
        }).then(responses => {
          // Response from Algolia:
          // https://www.algolia.com/doc/api-reference/api-methods/search/#response-format
          var results = responses.hits
          console.log('responses for query: ' + query + ', number of results: ' + results.length)
          console.log(results)
          for (var i = 0; i < results.length; i++) {
            var obj = results[i]
            console.log(obj)
            this.grapes.push(obj)
          }
        })
      },
      loadMore: function () {
        var vm = this
        var query = vm.$route.params.term
        var client = algoliasearch('BLP5M7YD97', 'e43146fabb439a15a2622c0264710cb6')
        var index = client.initIndex(vm.grapesDatabase)
        if (!this.isLoading && this.enableLoadMore) {
          vm.currentPage = vm.currentPage + 1
          this.isLoading = true
          index.search({
            query: query,
            page: vm.currentPage,
            hitsPerPage: vm.pageLimit
          }).then(responses => {
            // Response from Algolia:
            // https://www.algolia.com/doc/api-reference/api-methods/search/#response-format
            var results = responses.hits
            console.log('responses for query: ' + query + ', number of results: ' + results.length)
            console.log(results)
            for (var i = 0; i < results.length; i++) {
              var obj = results[i]
              this.grapes.push(obj)
            }
            setTimeout(function () {
              vm.isLoading = false
            }, 2000)
          })
        }
      }
    },
    components: {
      Grape
    }
  };
</script>

<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  #add-grape-button {
    width: 100%;
    margin: 0 auto 20px;
    background: #36a731;
    color: #fff;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 15px 20px;
  }
  #search-grapes {
    width: 60%;
    margin: 0 auto 20px;
    line-height: 30px;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
  }
  #home-grapes {
    margin-top: 40px;
  }
  .aux-col {
    box-sizing: border-box;
    padding: 30px 50px;
    text-align: left;
  }
  .aux-col > h5 {
    text-transform: uppercase;
    border-bottom: 1px solid #36a731;
    margin: 0 0 20px;
    padding-bottom: 8px;
    display: inline-block;
  }
  #search-results-grapes {
    margin-top: 40px;
  }
</style>


// WEBPACK FOOTER //
// src/components/search.vue